export enum UpsertMembershipActiveStep {
    Detail = 'Detail',
    Pricing = 'Pricing',
    Options = 'Options',
}
